import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCradlLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_4068_47261",
		style: { maskType: "luminance" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 40,
		height: 38,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M39.3655 0H0.634766V38H39.3655V0Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_4068_47261)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M5.91507 10.8899L2.02897 14.6593C2.02897 14.6593 -1.10799 17.9146 2.02897 22.1681C5.16594 26.4217 11.5335 31.7805 11.5335 31.7805L15.2792 27.6933C15.2792 27.6933 18.2757 24.2417 15.2792 20.5777C12.7106 17.4368 5.91507 10.8899 5.91507 10.8899Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.43506 10.3747L10.3212 14.144C10.3212 14.144 13.6772 17.1868 18.0624 14.144C22.4477 11.1013 27.9725 4.92494 27.9725 4.92494L23.7586 1.29179C23.7586 1.29179 20.2003 -1.61473 16.4228 1.29179C13.1847 3.78322 6.43506 10.3747 6.43506 10.3747Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34.087 26.6938L37.9731 22.9244C37.9731 22.9244 41.1101 19.6691 37.9731 15.4156C34.8361 11.1621 28.4686 5.80322 28.4686 5.80322L24.7229 9.89052C24.7229 9.89052 21.7264 13.342 24.7229 17.006C27.2914 20.1468 34.087 26.6938 34.087 26.6938Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.8018 32.8778L15.6879 36.6472C15.6879 36.6472 19.0439 39.69 23.4292 36.6472C27.8144 33.6046 33.3392 27.4282 33.3392 27.4282L29.1253 23.795C29.1253 23.795 25.567 20.8884 21.7895 23.795C18.5514 26.2864 11.8018 32.8778 11.8018 32.8778Z",
				fill: "black"
			})
		]
	})]
});
export default SvgCradlLogo;
